<div class="inspections-card-container">
    <img [src]="card().imgLink">

    <div class="inspections-card-text-container">

        <h4 class="update-text-title">{{card().title}}</h4>
        <p class="update-text-content">{{card().content}}</p>
        <a class="update-text-link" [href]="card().link">Más información <fa-icon icon="chevron-right"></fa-icon> </a>

    </div>
</div>
